import styled, { css, DefaultTheme } from 'styled-components';

import { ModeProps } from './types';

const modifier = {
	light: (theme: DefaultTheme) => css`
		background-color: ${theme.colors.white};
		${TitleCard} {
			color: ${theme.colors.portoSeguros100};
		}

		${TitleText} {
			color: ${theme.colors.black85};
		}
		${CTALink} {
			color: ${theme.colors.portoSeguros100};
		}
	`,
	dark: (theme: DefaultTheme) => css`
		background-color: ${theme.colors.black85};
		${TitleCard} {
			color: ${theme.colors.white};
		}
		${TitleText} {
			color: ${theme.colors.black60};
		}
		${CTALink} {
			color: ${theme.colors.white};
		}
	`,
};

export const Container = styled.div<ModeProps>`
	${({ theme, mode }) => css`
		padding: 2.3rem 2.4rem 3rem 2.8rem;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 100%;
		height: auto;

		${!!mode && modifier[mode](theme)};

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			padding-bottom: 2.7rem;
		}
		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			padding-bottom: 2.1rem;
		}
		@media (min-width: ${theme.breakpoints.desktop}) {
			padding-bottom: 2.9rem;
		}
		@media (min-width: ${theme.breakpoints.ultraWide}) {
			padding-top: 2.3rem;
			padding-bottom: 2.9rem;
		}
	`}
`;

export const Link = styled.a`
	${() => css`
		text-decoration: none;
	`}
`;

export const TitleCard = styled.h2`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.bold};
		font-size: 2rem;
		line-height: 110%;
		letter-spacing: 0.02em;
		margin-bottom: 1.6rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			margin-bottom: 3.6rem;
		}
		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			margin-bottom: 1.6rem;
		}
		@media (min-width: ${theme.breakpoints.desktop}) {
			font-size: 2rem;
			line-height: 2.4rem;
			margin-bottom: 2.4rem;
		}
		@media (min-width: ${theme.breakpoints.ultraWide}) {
			font-size: 2rem;
			line-height: 2.2rem;
		}
	`}
`;

export const ItemCombo = styled.div`
	${({ theme }) => css`
		display: grid;
		row-gap: 3.6rem;
		column-gap: 1.6rem;
		grid-template-columns: 1fr 1fr;
		margin-bottom: 1rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			margin-bottom: 4.2rem;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			row-gap: 1.6rem;
			column-gap: 1.6rem;
			margin-bottom: 2.2rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			row-gap: 3rem;
			column-gap: 1.6rem;
			margin-bottom: 3.5rem;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			row-gap: 3.6rem;
			margin-bottom: 3.3rem;
		}
	`}
`;

export const ComboContainer = styled.div<ModeProps>`
	${({ theme, mode }) => css`
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		position: relative;
		overflow: hidden;

		&:hover img {
			outline: 2px solid
				${mode === 'light'
					? theme.colors.portoSeguros100
					: theme.colors.portoSeguros45};
			outline-offset: -2px;
		}
		&:hover h3 {
			color: ${mode === 'light'
				? theme.colors.portoSeguros100
				: theme.colors.portoSeguros45};
		}
	`}
`;

export const Image = styled.img`
	${({ theme }) => css`
		width: 100%;
		height: auto;
		border-radius: 16px;
		object-fit: cover;
		overflow: hidden;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			height: 18.8rem;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			height: 12.3rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			height: 12.1rem;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			height: 18.8rem;
		}
	`}
`;

export const TitleText = styled.h3`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.bold};
		line-height: 110%;
		letter-spacing: 0.03em;
		font-size: 1.4rem;

		@media (min-width: ${theme.breakpoints.mobile}) {
			font-size: 1.6rem;
			line-height: 1.8rem;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			font-size: 1.6rem;
			line-height: 1.8rem;
			letter-spacing: 0.03em;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			font-size: 1.6rem;
			line-height: 2.4rem;
			letter-spacing: -0.01em;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			font-size: 1.6rem;
			line-height: 1.8rem;
		}
	`}
`;

export const CTALink = styled.a`
	${({ theme }) => css`
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.semibold};
		text-decoration: none;
		font-size: 1.6rem;
		letter-spacing: 0.025em;
		line-height: 2rem;
		position: relative;
		overflow: hidden;
	`}
`;
